import { useRouter } from 'next/router'
import { Trans, useTranslation } from 'next-i18next'

import { LinkText, Paragraph } from '@/features/Listings/seo/elements'
import useFilterSlug from '@/features/Listings/seo/search-results-content/content/use-filter-slug'

const RentingIn = ({
  filterSlug,
  cityName,
  rentingTipsLink,
  rentingTipsLinkZh
}) => {
  const { t } = useTranslation()
  const router = useRouter()
  const isChinese = router.locale === 'zh'
  const { hasFilter, filterName } = useFilterSlug(filterSlug)
  const localizedLink =
    isChinese && rentingTipsLinkZh ? rentingTipsLinkZh : rentingTipsLink

  const filterNameWithFallback = hasFilter
    ? filterName
    : t('seo:an apartment to rent')

  return (
    <Paragraph>
      <Trans i18nKey="seo:Renting FILTER in CITY Paragraph">
        Finding {{ filterNameWithFallback }} in {{ cityName }} requires
        research, communication with{' '}
        <LinkText href="/landlords">landlords & property managers</LinkText>,
        securing references, and{' '}
        <LinkText href="https://liv.rent/blog/livrent/residential-tenancy-agreement-explained/">
          signing a lease
        </LinkText>
        . All this can add up to a lengthy endeavour if you’re not familiar with
        how to find an apartment in {{ cityName }}. To help you get started,
        here is a guide with{' '}
        <LinkText href={localizedLink}>
          tips for renting in {{ cityName }}
        </LinkText>
        .
      </Trans>
    </Paragraph>
  )
}

export default RentingIn
